import React from 'react';

const Contact = () => {
    return (
        <section className="py-5">
            <div className="container text-center">
                <h2 className="mb-4">Contacto</h2>
                <p className="text-muted">¿Quieres saber más sobre Amanda o sus libros? ¡Contáctala!</p>
                <a href="mailto:info@amandacalem.com" className="btn btn-primary">Enviar un mensaje</a>
            </div>
        </section>
    );
};

export default Contact;